module.exports = __webpack_public_path__ + "files/a5946c4cd188c73d8e77949aaf9c5066.png";